export default __webpack_public_path__ + "static/media/hinno.88023d5e.png";